export enum CaseNumberCounterType
{
        A = "21321311-0000-0000-0002-000000000001",
        M = "21321311-0000-0000-0002-000000000002",
}